import React, { useContext, useState, useEffect } from 'react'
import queryString from 'query-string'

import withView from 'core/components/withView'
import useFetch from 'core/hooks/use-fetch'

import { GlobalContext } from 'core/contexts/global-context'
import { getPostBackgrounds } from 'core/helpers/wp-data-helpers'
import usePersistedState from 'core/hooks/use-persisted-state'

import Window from 'core/components/Window'
import ConversationList from './ConversationList'
import ConversationContent from './ConversationContent'

const Conversations = props => {
  const global = useContext(GlobalContext)
  const [conversation, setConversation] = useState()
  const [open, setOpen] = useState(true)
  const [viewed, setViewed] = usePersistedState('conversationViews', [])

  const { loading, error, data } = useFetch('/conversations')

  useFetch('/page/conversations', {
    onSuccess: data => global.setBackground(getPostBackgrounds(data))
  })

  useEffect(() => {
    const params = queryString.parse(props.location.search)

    if (!data) return

    /**
     * Just to keep things clean, we're going to filter out viewed IDs
     * for conversation items that no longer exist.
     */
    setViewed(viewed.filter(v => !!data.find(item => item.ID === v)))

    /**
     * If there is a query parameter in the URL we need to show the
     * corresponding conversation (if there isn't already one selected)
     */
    if (params.id && !conversation) {
      const selected = data.find(item => item.ID === parseInt(params.id, 10))
      setConversation(selected)
    } else if (!global.mobile) {
      handleSelect(data[0])
    }
  }, [data])

  useEffect(() => {
    if (!open) setOpen(true)
  }, [props.location.key])

  const handleSelect = (item = null) => {
    if (!item) {
      return handleClose()
    }

    if (viewed.indexOf(item.ID) === -1) {
      setViewed([...viewed, item.ID])
    }

    setConversation(item)

    let path = '/conversations/'
    path += item ? `?id=${item.ID}` : ''

    props.history.replace(path)
  }

  const handleWindowClose = () => {
    setOpen(false)
  }

  const handleClose = () => {
    setConversation(null)
    props.history.replace('/conversations/')
  }

  return (
    <article className={props.className}>
      <Window
        resizable
        open={open}
        loading={loading}
        mobile={global.mobile}
        fullscreen={global.mobile}
        titlebar={global.mobile ? null : { title: props.title, close: handleWindowClose }}
        minWidth={600}
        maxWidth={1200}
      >
        <div className={`conversation ${global.mobile ? 'mod-mobile' : 'mod-desktop'}`}>
          <ConversationList
            titlebar={global.mobile ? { title: props.title } : null}
            data={data || []}
            handleSelect={handleSelect}
            conversation={conversation}
            loading={loading}
            viewed={viewed}
          />
          <ConversationContent
            titlebar={
              global.mobile
                ? { title: (conversation || {}).post_title || '', close: handleClose }
                : null
            }
            conversation={conversation}
          />
        </div>
      </Window>
    </article>
  )
}

export default withView(Conversations)
